import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cardcollectiontimes',
  templateUrl: './cardcollectiontimes.component.html',
  styleUrls: ['./cardcollectiontimes.component.css']
})
export class CardcollectiontimesComponent implements OnInit {
  @Input('card_recollection_times') card_recollection_times:any;
  @Input('loan') loan:any;
  @Output() saveRecollectionTimes = new EventEmitter();
  @Input('loading') loading:any;

  constructor() { }

  ngOnInit() {
  }
  save() { 
    this.saveRecollectionTimes.emit({ card_recollection_times: this.card_recollection_times })
  }
}
